import { HistorianDataPoint, SavedSearch, TimeMode } from '@types';
import { Device } from '@src/types/Device';
import { getDateTimeFromTimeMode, GPSCoordinates } from '@utils/index_ts';
import { SelectedDataPoint } from '@components/_shared/DataPointSearch/types';
import { dataPointDictInit } from '../historianUtils';

export interface SiteConfig extends GPSCoordinates {
  siteId: string;
  DataRate?: string | number;
}

export function createInitialSearch(
  config: SiteConfig,
  timeMode: TimeMode,
): SavedSearch {
  const startDateTime = getDateTimeFromTimeMode(timeMode, config).subtract(
    1,
    'hour',
  );
  const stopDateTime = getDateTimeFromTimeMode(timeMode, config);

  return {
    name: '',
    siteId: config.siteId,
    startDateTime,
    stopDateTime,
    interval: {
      value: config.DataRate ? Number(config.DataRate) : 1,
      unit: 'second',
    },
    aggregationFunctions: ['mean'],
    dataPoints: [{ ...dataPointDictInit, siteId: config.siteId }],
  };
}

export interface DeviceLookupMaps {
  byEngineeringId: Map<string, Device>;
  byDeviceId: Map<string, Device>;
}

export function createDeviceLookupMaps(devices: Device[]): DeviceLookupMaps {
  return {
    byEngineeringId: new Map(
      devices.map((device) => [device.engineeringId, device]),
    ),
    byDeviceId: new Map(devices.map((device) => [device.deviceId, device])),
  };
}

export function convertToHistorianDataPoint(
  point: SelectedDataPoint,
  deviceMaps: DeviceLookupMaps,
): HistorianDataPoint {
  const deviceKey = point.deviceId || '';
  const device =
    deviceMaps.byEngineeringId.get(deviceKey) ||
    deviceMaps.byDeviceId.get(deviceKey);
  const parentController = device?.parentControllerId
    ? deviceMaps.byDeviceId.get(device.parentControllerId)
    : null;

  return {
    axis: 'Y1',
    category: point.deviceType || '',
    siteId: point.siteId || '',
    unitId: parentController?.engineeringId || '',
    sourceDeviceId: point.deviceId || '',
    dataPoint: {
      pointName: point.pointName || '',
      dataType: point.dataType || '',
      displayName: null,
    },
    topic: point.topic,
    parentSourceDeviceId: device?.parentSourceDeviceId || '',
  };
}
